import { render } from "./YellowMeetingDetail.vue?vue&type=template&id=0f2628a6"
import script from "./YellowMeetingDetail.vue?vue&type=script&lang=js"
export * from "./YellowMeetingDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__